import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getPublicUser, incrementHookahCount, resetHookahCounter } from '../../services/publicUserApi';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useSelector } from 'react-redux';

const PublicUserProfileDetailsPage = () => {
    const { id } = useParams();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [actionMsg, setActionMsg] = useState(null);
    const roles = useSelector(state => state.auth.roles) || [];
    const isLoggedIn = roles.length > 0;

    useEffect(() => {
        setLoading(true);
        getPublicUser(id)
            .then(setUser)
            .catch(e => setError(e.message || 'Failed to load profile'))
            .finally(() => setLoading(false));
    }, [id]);

    const handleIncrement = async () => {
        try {
            const response = await incrementHookahCount(id, 1);
            setUser(u => ({ 
                ...u, 
                hookahs_count: response.hookahs_count || (u.hookahs_count + 1),
                points: response.points || u.points
            }));
            setActionMsg('Hookah count incremented!');
        } catch (e) {
            setActionMsg('Failed to increment hookah count.');
        }
    };

    const handleReset = async () => {
        try {
            const response = await resetHookahCounter(id);
            setUser(u => ({ 
                ...u, 
                hookahs_count: 0,
                points: response.points || 0
            }));
            setActionMsg('Hookah count reset!');
        } catch (e) {
            setActionMsg('Failed to reset hookah count.');
        }
    };

    if (loading) return <Box sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Typography>Loading...</Typography></Box>;
    if (error) return <Alert severity="error">{error}</Alert>;
    if (!user) return null;

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#181a1b' }}>
            <Card sx={{ width: 400, p: 2, boxShadow: 3, borderRadius: 3, background: '#232526', color: '#fff' }}>
                <CardContent>
                    <Typography variant="h5" sx={{ mb: 2, fontWeight: 700, color: '#ff6b00', textAlign: 'center' }}>
                        Loyalty Profile Details
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 1, textAlign: 'center' }}>
                        <b>Name:</b> {user.name}<br />
                        <b>Phone:</b> {user.phone}<br />
                        <b>Email:</b> {user.email}<br />
                        <b>Hookahs:</b> {user.hookahs_count}<br />
                        <b style={{ color: '#ff6b00' }}>Points:</b> <span style={{ color: '#ff6b00', fontWeight: 'bold' }}>
                            {parseFloat(user.points || 0).toFixed(2)}
                        </span>
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
                        <img
                            src={process.env.REACT_APP_API_URL + '/' + user.qr_code_path}
                            alt="QR Code"
                            style={{ width: 120, height: 120, background: '#fff', padding: 8, borderRadius: 8 }}
                        />
                    </Box>
                    {isLoggedIn && (
                        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 2 }}>
                            <Button variant="contained" color="primary" onClick={handleIncrement} sx={{ background: '#ff6b00', '&:hover': { background: '#ff8533' } }}>
                                Increment Hookah
                            </Button>
                            <Button variant="outlined" color="secondary" onClick={handleReset} sx={{ borderColor: '#ff6b00', color: '#ff6b00', '&:hover': { borderColor: '#ff8533', color: '#ff8533' } }}>
                                Reset Hookahs
                            </Button>
                        </Box>
                    )}
                    {actionMsg && <Alert severity="info" sx={{ mt: 2 }}>{actionMsg}</Alert>}
                </CardContent>
            </Card>
        </Box>
    );
};

export default PublicUserProfileDetailsPage;
